// extracted by mini-css-extract-plugin
export default {"container":"DemoModeInfo_container__tovIJ","iconWrapper":"DemoModeInfo_iconWrapper__2-EU6","title":"DemoModeInfo_title__qBt7W","description":"DemoModeInfo_description__jAW-Q"};